const PasoDobleLead = {
    name: "Paso Doble",
    bpm: 112,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default PasoDobleLead;